module.exports = __webpack_public_path__ + "static/media/transparency-data.e744d152.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/transparency-data.jpg
// module id = 575
// module chunks = 0